/**
 * 검침 이미지 "자세히 보기" 오버레이 위치.
 *
 * 데스크탑은 뒤쪽 목록/차트를 가리지 않도록 화면 왼쪽에 작게 띄우지만,
 * 그 크기(32vw)를 모바일에 그대로 쓰면 화면 폭의 1/3짜리 상자가 되어
 * 확대해서 본다는 목적 자체가 없어진다. 그래서 모바일은 전체 화면을 쓴다.
 */
export const targetImageLightBoxStyle = (isMobile = false) => ({
  overlay: {
    zIndex: 2000,
    pointerEvents: 'none',
  },
  content: isMobile
    ? {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        margin: 0,
        pointerEvents: 'auto',
        background: 'transparent',
      }
    : {
        top: '15%',
        left: '5.5%',
        right: 'auto',
        bottom: 'auto',
        width: '32vw',
        height: '70vh',
        margin: 'auto',
        pointerEvents: 'auto',
        background: 'transparent',
      },
})
